import { useRef, useEffect } from 'react';

// Credits: https://codesandbox.io/embed/lp80n9z7v9

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export default usePrevious;
